<div class="painel-site">
    <div class="header">
        <div class="div-marca">
            <div class="marca">
                <img class="img-logo" src="/assets/images/logo.png">
            </div>
        </div>
        <div class="menu-conteiner">
            <div *ngIf="empresas.length > 1">
                <p-dropdown [options]="empresas" [(ngModel)]="empresaSelecionada" optionLabel="fantasia" (onChange)="alterarEmpresa()"></p-dropdown>
            </div>
            <div class="item-menu " [ngClass]="{'selected':rotaSelecionada=='conteudo'}">
                <span class="uppercase" (click)="navegar('conteudo','admin/conteudo')" translate>CONTEUDOS</span>
            </div>
            <div class="item-menu" [ngClass]="{'selected':rotaSelecionada=='publicacao'}">
                <span class="uppercase"   (click)="navegar('publicacao','admin/publicacao')" translate>PUBLICACOES</span>
            </div>
            <div *ngFor="let tela of telas" class="item-menu" [ngClass]="{'selected':rotaSelecionada==tela.nome}">
                <span class="uppercase" (click)="navegar(tela.nome, tela.url)" translate>{{tela.nome}}</span>
            </div>
            <!-- <div class="item-menu" [ngClass]="{'selected':rotaSelecionada=='playlist'}">
                <span class="uppercase" (click)="navegar('playlist','admin/playlist/panel/(pesquisa:playlist-pesquisa//cadastro:playlist-cadastro)')" translate>CAMPANHAS</span>
            </div>
            <div class="item-menu" [ngClass]="{'selected':rotaSelecionada=='player'}">
                <span class="uppercase" (click)="navegar('player','admin/player/panel/(pesquisa:player-pesquisa//cadastro:player-cadastro)')" translate>PLAYERS</span>
            </div>
            <div class="item-menu" [ngClass]="{'selected':rotaSelecionada=='grupo'}">
                <span class="uppercase" (click)="navegar('grupo','admin/grupoplayer/panel/(pesquisa:grupoplayer-pesquisa//cadastro:grupoplayer-cadastro)')" translate>GRUPO</span>
            </div> -->
            <!-- <div class="item-menu" [ngClass]="{'selected':rotaSelecionada=='relatorio'}">
                <span routerLink="relatorio"  (click)="navegar('relatorio')" translate>RELATORIOS</span>
            </div> -->
            <!-- <div class="item-menu" [ngClass]="{'selected':rotaSelecionada=='usuario'}">
                <span routerLink="usuario" (click)="navegar('usuario')"  translate>USUARIOS</span>
            </div> -->
            <div class="item-menu" [ngClass]="{'selected':rotaSelecionada=='configuracao'}" >
                <span class="uppercase" (click)="menu.toggle($event);this.rotaSelecionada = 'configuracao'"  translate>CONFIGURACAO</span>
                <p-menu #menu [popup]="true" [model]="itensConfiguracao"></p-menu>
            </div>
            <div class="item-menu" [ngClass]="{'selected':rotaSelecionada=='ajuda'}">
                <span class="uppercase"  (click)="navegar('ajuda','admin/ajuda')" translate>AJUDA</span>
            </div>
            <div class="item-menu" [ngClass]="{'selected':rotaSelecionada=='sair'}">
              <span class="uppercase"  (click)="navegar('sair','/login')" translate>SAIR</span>
            </div>
            <!-- <div>
                <p-avatar image="{{usuario?.foto == null ? '/assets/images/perfil.jpg': usuario?.foto}}" shape="circle"  (click)="menuUsuario.toggle($event)"></p-avatar>
                <p-menu #menuUsuario [popup]="true" [model]="itemsMenuUsuario"></p-menu>
            </div> -->
        </div>
    </div>
    <div class="painel-site-content">
        <router-outlet></router-outlet>
    </div>

</div>
